import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';
import { LogProvider } from '../log/log';

/*
  Generated class for the LinksProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LinksProvider {

  private api: string = "";

  constructor(public http: Http, public global:GlobalProvider, public log:LogProvider) {
    this.api = this.global.api;
   
  }


  // Devuelve todos los poenentes de un congreso
  public all(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tabla":"links",
      "campofiltro":"clavecongreso",
      "valorfiltro": clavecongreso, 
      "campoorden": "orden"
    };
   
    
    return this.http.post(this.api+"apigen/list.php", parametros, options).map(
      (response) => {
       
      
        return response.json();
        
      }
    ).catch(this.handleError);
  }

  // Elimina un congreso
  public delete(nlink): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "links",
      "clave": nlink,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(congreso,link): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    link.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "links",
      "parametros": link
    };
  
    
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso,link): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "links",
      "clave": link.clave,
      "parametros": link
    };
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
         
         return respuesta[0];
      }
    ).catch(this.handleError);
  }


  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
  public ordena(congreso,links): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "links",
      "parametros": links
    };
  
    return this.http.post(this.api+"apigen/orden.php", parametros, options).map(
      (response) => {
      
        return response.json(); 
      }
    ).catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/links/links.ts